import { EMPTY, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { OAuthService } from 'angular-oauth2-oidc';
import { AppConfig } from '../../app.config';
import { UsageStatistics } from './usage-statistics';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    private urlPortalUsersBackend: string = this.config.backendPortalUsersUri + "WebAPI/api/";
    private urlPortalBackend: string = this.config.backendPortalUri + "WebAPI/api/";
    private urlIwmBackend: string = this.config.backendIwmUri;
    private urlHasProductUsageright: string = "Product/HasUsageRight?productId={0}&includePartnerLicenses={1}";
    private urlCompanyHasLicenseToProduct: string = "Product/CompanyHasLicenseToProduct?productId={0}";
    private urlCompanyHasLicenseToInventories: string = "InventoryApi/Inventories/HasProductAccess";
    private urlUsageStatistic: string = "UsageStatistics/Post?apiKey={0}";
    private hasUsageDataBeenSent: boolean = false;

    public hasOnlyIwdLicense: boolean = false;

    constructor(private oauthService: OAuthService, private http: HttpClient, private config: AppConfig) { }

    /**
     * Check for user's product rights for a single product
     * @param {number} productId Product Id
     * @param {boolean} includePartnerLicenses Boolean indicating whether to take partner licenses into account. 
     * True as default, set to false when requesting IWM product right.
     * @returns {Observable<boolean>} Observable of user's product right (true if user has rights)
     */
    public hasProductUsageRight(productId: number, includePartnerLicenses: boolean = true): Observable<boolean> {
        const url = this.urlPortalUsersBackend + this.urlHasProductUsageright.replace('{0}', productId.toString())
            .replace('{1}', includePartnerLicenses.toString());
        return this.fetchData(url);
    }

    public companyHasLicenseToProduct(productId: number): Observable<boolean> {
        const url = this.urlPortalUsersBackend + this.urlCompanyHasLicenseToProduct.replace('{0}', productId.toString());
        return this.fetchData(url);
    }

    public companyHasLicenseToInventory(): Observable<string> {
        const url = this.urlIwmBackend + this.urlCompanyHasLicenseToInventories;
        return this.http.get<string>(url);
    }

    public addUsageStatistics(page: string): Observable<any> {
        if (!this.hasUsageDataBeenSent) {
            const url = this.urlPortalBackend + this.urlUsageStatistic.replace('{0}', this.config.productApiKey);
            const claims: any = this.oauthService.getIdentityClaims();

            let usageStatistics = new UsageStatistics();
            usageStatistics.UserId = claims['sub'];
            usageStatistics.CompanyId = claims['headpower:company_uuid'];
            usageStatistics.Page = page;
            usageStatistics.RemoteAddress = '';

            this.hasUsageDataBeenSent = true;

            return this.http.post(url, usageStatistics);
        }

        return EMPTY;
    }

    private fetchData(url: string): Observable<boolean> {
        return this.http.get<boolean>(url);
    }
}
